import { useState, useEffect, useRef, useCallback } from 'react';

export const useStickyElement = (defaultSticky = false, topOffset = 80) => {
  const [isSticky, setIsSticky] = useState(defaultSticky);
  const elementRef = useRef(null);

  const toggleStickiness = useCallback(
    ({ top }) => {
      if (
        // Magic number for navigation height.
        top <= topOffset
      ) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    },
    [isSticky],
  );

  useEffect(() => {
    const handleScroll = () => {
      // Check if element is in view with offsetParent. Returns null if hidden.
      if (elementRef.current && elementRef.current.offsetParent)
        toggleStickiness(elementRef.current.getBoundingClientRect());
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [toggleStickiness]);

  return { elementRef, isSticky };
};
